import React from 'react';
import PropTypes from 'prop-types';

import DataCard from '../../../common/card/DataCard';

import { formatTimestamp } from '../../../../utils/formatTimestamp';

export const KeyDetails = ({ data, onEdit, isService = false }) => {
  const {
    id,
    orderCode,
    status,
    createdAt,
    completedAt,
    dueDate,
    isProcessedAtHub,
    isBagTrackingEnabled,
    isAdjusted,
    balanceDue,
    orderType,
    paymentTiming,
  } = data;

  const details = [
    { label: 'ID', data: id },
    { label: 'Code', data: orderCode },
    { label: 'Status', data: status === 'CANCELLED' ? 'CANCELED' : status, editable: true },
    { label: 'Created At', data: formatTimestamp(createdAt) },
    { label: 'Completed At', data: formatTimestamp(completedAt), isHidden: !isService },
    { label: 'Due Date', data: formatTimestamp(dueDate), isHidden: !isService },
    { label: 'Processed at Hub?', data: isProcessedAtHub ? 'YES' : 'NO', isHidden: !isService },
    {
      label: 'Bag Tracking Enabled?',
      data: isBagTrackingEnabled ? 'YES' : 'NO',
      isHidden: !isService,
    },
    { label: 'Was Order Adjusted?', data: isAdjusted ? 'YES' : 'NO', isHidden: !isService },
    { label: 'Balance Due', data: balanceDue, isHidden: isService },
    {
      label: 'Order Origination Type',
      data: orderType === 'SERVICE' || orderType === 'INVENTORY' ? 'IN-STORE' : 'ONLINE',
    },
    { label: 'Payment Timing', data: paymentTiming },
  ];

  const filteredDetails = details.filter(({ isHidden }) => !isHidden);

  return (
    <DataCard
      title="Key Details"
      cardData={filteredDetails}
      onEdit={(modalType) => onEdit(modalType.toLowerCase())}
    />
  );
};

KeyDetails.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.number,
    orderCode: PropTypes.string,
    status: PropTypes.string,
    createdAt: PropTypes.string,
    completedAt: PropTypes.string,
    isProcessedAtHub: PropTypes.bool,
    isBagTrackingEnabled: PropTypes.bool,
    isAdjusted: PropTypes.bool,
    balanceDue: PropTypes.number,
    orderType: PropTypes.string,
    paymentTiming: PropTypes.string,
  }).isRequired,
  onEdit: PropTypes.func.isRequired,
  isService: PropTypes.bool,
};
